import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { useParams } from "react-router-dom"; 
import * as api from "../../../actions/api";
import YearFormData from "./YearFormData";
import swal from "sweetalert";
import { useTranslation } from "react-i18next";


const EditYear = (props) => {

    //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "year";
  const UserInfo = sessionStorage.getItem("User_info")
  ? JSON.parse(sessionStorage.getItem("User_info"))
  : 0;  
  const UserName = UserInfo==0?'': UserInfo[0].id;
  const { t, i18n } = useTranslation();

  const [formData, setFormData] = useState({
    DeadLine: "",
    PackageYear: "",
    CurrentYear: "",
    bCatalogLocked:""
  });

  const [selectedDate, setSelectedDate] = useState(
    new Date()
  );
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  useQuery(
    ["year", id],
    () =>
      api.getYear(id).then((res) => {
        setFormData(res.data);
        return res.data;
      }),
    {
      enabled: Boolean(id),
    }
  );

  // const { mutate } = useMutation(api.updateYear, {
  //   onSuccess: (data) => { 
  //     if (data.status == 200) {



  //       api.getAllDropdown('PackageYearList').then((response) => {
  //         localStorage.setItem(
  //           "PackageYearList",
  //           JSON.stringify(response.datalist.PackageYearList)
  //         );
  //       })


        
  //       const auth_token = sessionStorage.getItem("token")
  //       ? sessionStorage.getItem("token")
  //       : null;
  //       let options = {};
  //       options = {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${auth_token}`,
  //         },
  //         task:'UOM'
  //       };

        
       

  //       props.openNoticeModal({
  //         isOpen: true,
  //         msg: data.data.message,
  //         msgtype: data.data.success,
  //       });

  //       queryClient.getQueriesData("Year"); // include the page name
  //       props.history.push("/year"); //page url
  //       api.dirtyModeDisable();
  //     }else{

  //       props.openNoticeModal({
  //         isOpen: true,
  //         msg: data.message,
  //         msgtype: data.success,
  //       });
  //     }
  //   },
  // });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = { ...formData };
    data[name] = value;

    setFormData(data);
    setErrorObject({ ...errorObject, [name]: null });
    api.dirtyModeEnable();
  };

  const handleRDateChange = (date, field) => {
  
    setFormData({ ...formData, [field]: date });
    setErrorObject({ ...errorObject, [field]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
    api.dirtyModeEnable();
  };
  
  const handleReset = () => {
    setFormData({
      DeadLine: "",
      PackageYear: "",
      CurrentYear: "",
      bCatalogLocked:""
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["PackageYear"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  function checkValidateForm(){

     
    if (validateForm(formData)) {
    let fDtat={...formData,"menukey": menukey,"lan":lan,"UserName":UserName,}; 
   
    return fDtat;
    }else{
    return false;
    }

};
  // const handleUpdate = async (e) => {
  //   if (validateForm(formData)) {
  //     let fDtat={...formData,"menukey": menukey,"lan":lan,"UserName":UserName}; 
  //     mutate(fDtat);
     
       
  //   }
  // };

  const handleCheckYear = (e) => {
    const { name, checked } = e.target;
    
    let bDispenseVal = checked;
        swal({
          title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
          text:
            bDispenseVal == true
              ? t(
                  DispensingLanguage[lan][menukey][
                    "Do you want to lock for editing in this year?"
                  ]
                )
              : t(
                  DispensingLanguage[lan][menukey][
                    "Do you want to unlock for editing in this year?"
                  ]
                ),
          icon: "warning",
          buttons: [t(DispensingLanguage[lan][menukey]["No"]), 
          t(DispensingLanguage[lan][menukey]["Yes"])],
          dangerMode: true,
        }).then((willDelete) => {
          if (willDelete) {
            setFormData({ ...formData, [name]: checked });
  
          } else {
            //refetch();
          }
        });
  
    //setFormData({ ...formData, [name]: checked });
  };

  return (
    <>
      <YearFormData
        errorObject={errorObject}
        addNationalSupplierForm={false}
        formData={formData}
        handleChange={handleChange}
        handleRDateChange={handleRDateChange} 
        handleCheck={handleCheck}
        handleCheckYear={handleCheckYear}
        selectedDate={selectedDate} 
        handleReset={handleReset}
        checkValidateForm={checkValidateForm}
        // handleUpdate={handleUpdate}
        bStockUpdate={props.permissionType}
        {...props}
      />
    </>
  );
};

export default EditYear;
